export const createMeter = `
    mutation createMeter($input: CreateMeterInput!) {
        createMeter(input:$input) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
    }
}`;

export const updateMeter = `
    mutation updateMeter($input: UpdateMeterInput!) {
        updateMeter(input:$input){
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;

export const deleteMeter = `
    mutation deleteMeter($input: DeleteMeterInput!) {
        deleteMeter(input:$input)
}`;

// FNP-665: narrow status-only activation. Use this (NOT updateMeter) to flip a meter
// DRAFT->ACTIVE. updateMeter has an owner-guard that silently no-ops for catalog
// (deploy-hook-created) meters; activateMeter has no owner guard.
export const activateMeter = `
    mutation activateMeter($id: ID!) {
        activateMeter(id: $id) {
            id
            name
            meterCode
            aggregation
            grain
            unit
            resetPolicy
            purpose
            latenessWindowMinutes
            watermarkDelayMinutes
            status
            dimensions {
                name
                apiKey
            }
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated
        }
}`;
